import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconExternalAccessLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 21,
	viewBox: "0 0 15 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1 6.34857C1.2208 5.13183 1.78678 4.00278 2.63149 3.09386C3.4762 2.18496 4.56464 1.53388 5.76914 1.21705C6.97373 0.900235 8.24431 0.930794 9.43198 1.30513C10.6196 1.67946 11.6751 2.38206 12.4745 3.33048C13.2738 4.27892 13.7839 5.43379 13.945 6.65972C14.1061 7.88565 13.9115 9.13178 13.3839 10.2518C12.8564 11.3719 12.0178 12.3194 10.9665 12.9833C9.9153 13.6471 8.69498 13.9999 7.44883 14",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14 14.7183C13.7793 15.935 13.2133 17.0641 12.3686 17.9731C11.5238 18.882 10.4354 19.533 9.23088 19.8498C8.02629 20.1667 6.75571 20.1361 5.56805 19.7618C4.3804 19.3875 3.32499 18.6848 2.52558 17.7364C1.72626 16.788 1.21606 15.6331 1.05498 14.4072C0.893899 13.1812 1.08849 11.9351 1.6161 10.8151C2.14361 9.69503 2.98224 8.74749 4.03343 8.0836C5.08472 7.41971 6.30494 7.06702 7.5511 7.06689",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgIconExternalAccessLink;
